import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from "prop-types";

export default function ConfirmDialog(props) {

  return (
    <div>
        <Dialog
            open={props.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">
          {props.dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.dialogBodyMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.handleCloseOnNo} autoFocus>Cancel</Button>
            <Button onClick={props.handleCloseOnYes} autoFocus>Yes</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ConfirmDialog.propTypes = {
    open: PropTypes.bool,
    dialogTitle: PropTypes.string.isRequired,
    dialogBodyMessage: PropTypes.string.isRequired,
    handleCloseOnYes: PropTypes.func.isRequired,
    handleCloseOnNo: PropTypes.func.isRequired
};